var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewCheckbox = function SvgNewCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 14.5,
    x: 4.75,
    y: 4.75,
    fill: "#fff",
    rx: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 14.5,
    x: 4.75,
    y: 4.75,
    stroke: "#CCC",
    strokeWidth: 1.5,
    rx: 1.25
  })));
};
export default SvgNewCheckbox;